/* eslint-disable react/prop-types */
/*
Author: Gilang Romadhanu Tartila
*/

import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  createStackNavigator,
  CardStyleInterpolators,
} from '@react-navigation/stack';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { isWeb } from '@global/screens';
import { showPopup } from '@/store/modal';
import {
  setTitleHeader,
  setDefaultStackOption,
  exportCsvApi,
  hasNoAccess,
} from '@global/helpers';

import HamburgerButton from '@components/navbar/HamburgerButton';
import NotificationSettingButton from '@components/navbar/NotificationSettingButton';
import BackButton from '@components/navbar/BackButton';
import MoreButton from '@components/navbar/MoreButton';
import ActionButton from '@components/navbar/ActionButton';

import SalesTeamScreen from '@/screens/setting/sales-team/SalesTeamScreen';
import SalesTeamDetailScreen from '@/screens/setting/sales-team/SalesTeamDetailScreen';
import SalesTeamFormScreen from '@/screens/setting/sales-team/SalesTeamFormScreen';

const Stack = createStackNavigator();

const SalesTeamNavigator = ({ navigation }) => {
  const insets = useSafeAreaInsets();
  const dispatch = useDispatch();

  const goToForm = (props, isAdd = false) => {
    if (
      !isAdd &&
      props &&
      props.route &&
      props.route.params &&
      props.route.params.id
    ) {
      props.navigation.navigate('SalesTeamFormScreen', {
        titleScreen: props.route.params.name,
        name: props.route.params.name,
        id: props.route.params.id,
      });
    } else {
      props.navigation.replace('SalesTeamFormScreen');
    }
  };

  return (
    <Stack.Navigator
      initialRouteName="SalesTeamScreen"
      screenOptions={(props) => ({
        headerLeft: () => <HamburgerButton {...props} />,
        headerRight: () => <NotificationSettingButton {...props} />,
        ...setDefaultStackOption(insets, CardStyleInterpolators),
      })}>
      <Stack.Screen
        name="SalesTeamScreen"
        component={SalesTeamScreen}
        options={(props) => ({
          title: setTitleHeader('Sales Team'),
          headerRight: () => {
            const showFilter = () =>
              dispatch(showPopup({ name: 'showFilter', value: 'sales-teams' }));
            // eslint-disable-next-line react-hooks/rules-of-hooks
            const tempData = useSelector((state) => state.global.tempData);
            // const hasAccess = hasNoAccess([
            //   'regional_manager',
            //   'distributor_manager',
            //   'general_manager',
            //   'vice_president',
            // ]);
            const exportSalesTeam = async () => {
              if (tempData?.length) {
                const finalData = JSON.parse(JSON.stringify(tempData));
                dispatch(showPopup({ name: 'isLoading', value: true }));
                try {
                  exportCsvApi('sales-teams', {
                    document: {
                      _id: { $in: finalData },
                    },
                  });
                  dispatch(showPopup({ name: 'isLoading', value: false }));
                } catch (error) {
                  dispatch(showPopup({ name: 'isLoading', value: false }));
                }
              }
            };
            const menus = [
              { type: 'function', name: 'Filter', callback: showFilter },
              { type: 'function', name: 'Export', callback: exportSalesTeam },
            ];
            // if (hasAccess) {
            //   menus.unshift({
            //     type: 'function',
            //     name: 'Add',
            //     callback: () => goToForm(props, true),
            //   });
            // }
            return isWeb ? (
              <NotificationSettingButton {...props} />
            ) : (
              <MoreButton menu={menus} {...props} />
            );
          },
        })}
      />
      <Stack.Screen
        name="SalesTeamDetailScreen"
        component={SalesTeamDetailScreen}
        options={(props) => {
          const hasAccess = hasNoAccess([
            'regional_manager',
            'regional_support',
            'key_account_manager',
            'group_key_account_manager',
            'national_key_account_manager',
            'distributor_manager',
            'general_manager',
            'vice_president',
            'regional_distributor_manager',
          ]);
          const route = props.route;
          let title = 'Sales Team Detail';
          if (route.params && route.params.titleScreen) {
            title = route.params.titleScreen;
          }
          return {
            title: setTitleHeader(title),
            headerLeft: () => (
              <BackButton
                {...props}
                // navigate() to the list — history stays aligned because the
                // edit form used replace() (no sandwiched detail entry).
                onPress={() => props.navigation.navigate('SalesTeamScreen')}
              />
            ),
            headerRight: () =>
              isWeb ? (
                <NotificationSettingButton {...props} />
              ) : hasAccess ? (
                <ActionButton
                  icon={require('@assets/img/icons/edit-white.svg')}
                  onCallback={() => goToForm(props)}
                />
              ) : null,
          };
        }}
      />
      <Stack.Screen
        name="SalesTeamFormScreen"
        component={SalesTeamFormScreen}
        options={(props) => {
          const route = props.route;
          let title = 'Add Sales Team';
          let params = {};
          let isEdit = false;
          if (route.params && route.params.titleScreen) {
            title = route.params.titleScreen;
            params = route.params;
            isEdit = true;
          }
          return {
            title: setTitleHeader(title),
            headerLeft: () => (
              <BackButton
                {...props}
                isJump={true}
                customBack={{
                  screen: isEdit ? 'SalesTeamDetailScreen' : 'SalesTeamScreen',
                  params: params,
                }}
              />
            ),
            headerRight: () =>
              isWeb ? <NotificationSettingButton {...props} /> : false,
          };
        }}
      />
    </Stack.Navigator>
  );
};

export default SalesTeamNavigator;
